/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReadAddressDto } from './ReadAddressDto';
import {
    ReadAddressDtoFromJSON,
    ReadAddressDtoFromJSONTyped,
    ReadAddressDtoToJSON,
    ReadAddressDtoToJSONTyped,
} from './ReadAddressDto';

/**
 * Minimal real estate data for search results
 * @export
 * @interface SearchRealEstateDto
 */
export interface SearchRealEstateDto {
    /**
     * Unique identifier of the real estate
     * @type {string}
     * @memberof SearchRealEstateDto
     */
    id?: string;
    /**
     * Name of the real estate
     * @type {string}
     * @memberof SearchRealEstateDto
     */
    name?: string;
    /**
     * 
     * @type {ReadAddressDto}
     * @memberof SearchRealEstateDto
     */
    address?: ReadAddressDto;
    /**
     * Type of property (enum value)
     * @type {number}
     * @memberof SearchRealEstateDto
     */
    propertyType?: number;
    /**
     * Area in square meters
     * @type {number}
     * @memberof SearchRealEstateDto
     */
    area?: number;
    /**
     * Number of rooms
     * @type {number}
     * @memberof SearchRealEstateDto
     */
    roomCount?: number;
}

/**
 * Check if a given object implements the SearchRealEstateDto interface.
 */
export function instanceOfSearchRealEstateDto(value: object): value is SearchRealEstateDto {
    return true;
}

export function SearchRealEstateDtoFromJSON(json: any): SearchRealEstateDto {
    return SearchRealEstateDtoFromJSONTyped(json, false);
}

export function SearchRealEstateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRealEstateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : ReadAddressDtoFromJSON(json['address']),
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
        'area': json['area'] == null ? undefined : json['area'],
        'roomCount': json['roomCount'] == null ? undefined : json['roomCount'],
    };
}

export function SearchRealEstateDtoToJSON(json: any): SearchRealEstateDto {
    return SearchRealEstateDtoToJSONTyped(json, false);
}

export function SearchRealEstateDtoToJSONTyped(value?: SearchRealEstateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': ReadAddressDtoToJSON(value['address']),
        'propertyType': value['propertyType'],
        'area': value['area'],
        'roomCount': value['roomCount'],
    };
}

